import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { Link } from 'react-router'
import classnames from 'classnames'
import Tooltip from 'react-tooltip'

import Icon from '../../shared/components/Icon'

import PaneWrapper from './PaneWrapper'
import List from './SimpleList'

export default class Pane extends Component {

  static propTypes = {
    canCreateGuidedTour: PropTypes.bool,
    data: PropTypes.object,
    onLoad: PropTypes.func
  }

  render() {
    const { canCreateGuidedTour, data } = this.props
    return (
      <PaneWrapper>
        <h1 className="with-tools">
          Führungen
          <span className="tools">
            <button
              className="btn btn-sm btn-default"
              onClick={this.props.onLoad}
            >
              Aktualisieren
            </button>
          </span>
        </h1>

        <div className="toolbar">

          <span className="tools">
            <Link
              to={canCreateGuidedTour
                ? '/guidedTour/create'
                : window.location.pathname}
              className={
                classnames('btn-link', { disabled: !canCreateGuidedTour })
              }
              disabled={!canCreateGuidedTour}
              data-tip={!canCreateGuidedTour
                ? 'Mindestens ein Programm muss erstellt<br/>und freigegeben sein (online sein),<br />um eine Führung erstellen zu können.'
                : null}
            >
              <Icon
                className="tool-icon"
                size={18}
                name={`plus-${canCreateGuidedTour ? 'turquoise' : 'grey'}`}
              />
              Neue Führung
            </Link>
            {canCreateGuidedTour
              ? null
              : (
                <Tooltip
                  className="tooltip"
                  html
                  place="top"
                  type="info"
                />
              )}
          </span>

        </div>

        <div className="vertical v-scrollable pane-list-container">
          <List
            filter={{ isDeactivated: false }}
            guidedTour={data}
          />
          <h5>Deaktivierte Führungen</h5>
          <List
            filter={{ isDeactivated: true }}
            guidedTour={data}
          />
        </div>

      </PaneWrapper>
    )
  }

}



// WEBPACK FOOTER //
// ./src/guided-tour/components/Pane.js